import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button } from '@mui/material';
import {
	deletecategoryDispatch,
	showagentDispatch,
} from 'reducers/HomeReducer';
import BasicModal from 'app/components/BasicModal';
import { setID, toggleModal } from 'reducers/UiReducer';
import { Link } from 'react-router-dom';

export default function CategoryTable() {
	const { agent, loginInfo } = useSelector((state) => state.home);
	const dispatch = useDispatch();
	const columns = [
		{ field: 'id', headerName: 'ID', width: 90 },
		{
			field: 'first_name',
			headerName: 'Name',
			width: 150,
			editable: true,
		},
		{
			field: 'email',
			headerName: 'Email',
			width: 200,
			editable: true,
		},
		{
			field: 'mobile',
			headerName: 'Mobile',
			width: 200,
			editable: true,
		},
		{
			field: 'agency_name',
			headerName: 'Agency Name',
			width: 200,
			editable: true,
		},
		{
			field: 'wallet_amount',
			headerName: 'Balance (₹)',
			width: 200,
			editable: true,
		},
		{
			field: 'action',
			headerName: 'Action',
			width: 500,
			editable: false,
			renderCell: (cellValues) => {
				return (
					<Box style={{ display: 'flex', justifyContent: 'space-between' }}>
						<Button
							variant='contained'
							color='primary'
							style={{ marginLeft: 10, lineHeight: '1rem' }}
							onClick={(event) => {
								handleClickDelete(event, cellValues);
							}}>
							View
						</Button>
						<Button
							variant='contained'
							color='primary'
							style={{ marginLeft: 10, lineHeight: '1rem' }}
							onClick={(event) => {
								dispatch(toggleModal(true));
								dispatch(setID(cellValues.id));
							}}>
							Add Fund
						</Button>
						<Button
							variant='contained'
							color='primary'
							style={{ marginLeft: 10, lineHeight: '1rem' }}
							onClick={(event) => {
								handleClickDelete(event, cellValues);
							}}>
							Fetch Fund
						</Button>
						<Link to='/dashboard/agenttran'>
							<Button
								variant='contained'
								color='primary'
								style={{ marginLeft: 10, lineHeight: '1rem' }}
								// onClick={(event) => {
								// 	handleClickDelete(event, cellValues);
								// }}
							>
								Transaction
							</Button>
						</Link>
					</Box>
				);
			},
		},
	];
	const handleClick = (event, cellValues) => {};
	const handleClickDelete = (event, cellValues) => {
		dispatch(deletecategoryDispatch(cellValues.id, loginInfo));
	};
	React.useEffect(() => {
		let form = {
			id: loginInfo.result.id,
		};
		dispatch(showagentDispatch(form));
	}, []);
	return (
		<Box sx={{ height: 400, width: '100%' }}>
			{agent && agent?.result.length > 0 ? (
				<DataGrid
					rows={agent && agent?.result}
					columns={columns}
					initialState={{
						pagination: {
							paginationModel: {
								pageSize: 5,
							},
						},
					}}
					pageSizeOptions={[5]}
					checkboxSelection
					disableRowSelectionOnClick
				/>
			) : (
				''
			)}
			<BasicModal />
		</Box>
	);
}
